import React from "react";

export default function PageHeader({ title, sub, rSide }) {
  return (
    <div className="page-head">
      <div>
        <div className="page-title">{title || "-"}</div>
        <div className="page-sub">{sub ? sub : "-"}</div>
      </div>

      {rSide ? rSide : null}
    </div>
  );
}
